import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React from 'react';

type Props = React.ComponentProps<typeof Spin>;

const LoaderSpin = (props: Props) => {
  return (
    <Spin
      className="text-pink-500"
      indicator={<LoadingOutlined spin color="#fd9ffd" />}
      {...props}
    />
  );
};

export default LoaderSpin;
